import React, { useState } from 'react';
import { Button, FullModal } from '@sbt-web/ui';

export const AiDisclaimer = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <Button
        design="text"
        size="small"
        onClick={() => setIsOpen(true)}
        icon={
          <img
            src="/static/img/ui/info.svg"
            height={16}
            width={16}
            alt=""
            loading="lazy"
            decoding="async"
          />
        }
        aria-label="Più dettagli sulle domande frequenti"
      />

      <FullModal
        open={isOpen}
        title="Contenuto generato dall'IA"
        onClose={() => setIsOpen(false)}
        actions={[
          <Button key="closer" design="solid" onClick={() => setIsOpen(false)}>
            Ok, ho capito
          </Button>,
        ]}
      >
        <p>
          Il contenuto di questa sezione è generato automaticamente tramite
          intelligenza artificiale generativa supportata da Amazon Bedrock. Per
          ulteriori informazioni sul suo funzionamento,{' '}
          <a href="https://info.subito.it/policies/condizioni-generali.htm">
            clicca qui
          </a>
          . Il contenuto generato potrebbe essere impreciso, offensivo, di parte
          o tendenzioso e non rappresenta l'opinione di Subito.it. È necessario
          verificare tali contenuti ed essere cauti nel loro utilizzo o nel
          farvi affidamento. Se desideri segnalare qualsiasi problema relativo
          al contenuto generato dall'IA,{' '}
          <a href="https://assistenza.subito.it/hc/it/requests/new">
            clicca qui.
          </a>
        </p>
      </FullModal>
    </>
  );
};
